// extracted by mini-css-extract-plugin
module.exports = {"buttonsContent":"WithdrawalListMovileView_buttonsContent__o9qzG","buttons":"WithdrawalListMovileView_buttons__fZIeD"};